import Vue from 'vue';
import gql from 'graphql-tag';

export default {
    namespaced: true,
    state: {
        agb: false,
        otherAddress: false,
        createAccount: false,
        isPrivateCustomer: true,
    },
    getters: {
        getAgb: state => state.agb,
        getOtherAddress: state => state.otherAddress,
        getIsPrivateCustomer: state => state.isPrivateCustomer,
        getCreateAccount: state => state.createAccount,
        getCustomerData: (state, getters, rootState) => {
            return {
                username: rootState.Registration.email,
                password: rootState.Registration.password,
                passwordConfirmation: rootState.Registration.password,
                attributes: {
                    uid: rootState.Registration.uid,
                    isPrivateCustomer: state.isPrivateCustomer,
                },
            };
        },
    },
    mutations: {
        setAgb(state, value) {
            state.agb = value;
        },
        setOtherAddress(state, value) {
            state.otherAddress = value;
        },
        setIsPrivateCustomer(state, value) {
            state.isPrivateCustomer = value;
        },
        setCreateAccount(state, value) {
            state.createAccount = value;
        },
    },
    actions: {
        registerCustomer({ commit, getters }, options) {
            let data = getters.getCustomerData;
            return this.dispatch('Customer/registerCustomer', data, { root: true }).then(result => {
                if (result.success) {
                    commit('Login/setAuthToken', result.token, { root: true });
                }
                return result;
            });
        },
        setCustomerDataErrors({ commit, dispatch }, errors) {
            if (errors.username || errors.password || errors.passwordConfirmation) {
                commit(
                    'Registration/setErrors',
                    {
                        email: errors.username,
                        password: errors.password,
                        passwordConfirmation: errors.passwordConfirmation,
                    },
                    {
                        root: true,
                    },
                );
            }
            if (errors.general) {
                dispatch(
                    'NotificationModal/displayNotificationModal',
                    {
                        message: Object.values(errors).join('\n'),
                    },
                    { root: true },
                );
            }
        },
    },
};
